{
  "version": 1,
  "asset_id": "2f378d8d-712c-4c9e-8f2b-f6b003268de0",
  "project_id": "97176789-536c-4447-900d-52ecbc24e875",
  "url": "/__l5e/assets-v1/2f378d8d-712c-4c9e-8f2b-f6b003268de0/confidence-choices-kid.png",
  "r2_key": "a/v1/97176789-536c-4447-900d-52ecbc24e875/2f378d8d-712c-4c9e-8f2b-f6b003268de0/confidence-choices-kid.png",
  "original_filename": "confidence-choices-kid.png",
  "size": 1205368,
  "content_type": "image/png",
  "created_at": "2026-09-28T12:23:48Z"
}
